{
    "ChangeLayoutOptionTitle": "Klicken Sie hier, um die Optionen für das Dashboard-Layout anzuzeigen.",
    "NAME": "ChangeLayout"
}